<div>
    <!-- <app-header [title]="'menu.DESIGNER.my_bonuses' | translate" /> -->
    <app-generic-header [title]="'menu.DESIGNER.my-bonuses' | translate" [searcher]="false" [divider]="false"> </app-generic-header>
    <div class="cosentino-tab">
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.tab == 'TO_REQUEST' }" (click)="filterCommissions('TO_REQUEST')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'commissions.to_request' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.tab == 'REQUESTED' }" gtm-label="filter_draft" (click)="filterCommissions('REQUESTED')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'commissions.requested' | translate }}</span>
                </div>
            </div>
        </a>
    </div>

    <div class="p-4 mx-4 mt-4 mb-0 gap-4 flex flex-col">
        <div class="p-6 col-span-12 bg-white">
            <!-- pending_request headers -->
            <div class="pending-header" *ngIf="tab === 'TO_REQUEST'">
                <div class="pending-header-left">
                    <div class="pending-header-title-row">
                        <span class="typography-title-m">{{ 'commissions.available_commissions' | translate }}</span>
                        <div class="pending-header-select-desktop" *ngIf="hasBothInvoiceTypes">
                            <app-select
                                [small]="true"
                                [placeholder]="'select' | translate"
                                [options]="availableTypes"
                                [selectedValue]="selectedValue"
                                [required]="false"
                                [disabled]="false"
                                [searchable]="false"
                                [isClearable]="false"
                                (selectedValueChanged)="onApplicationFilter($event)"
                            ></app-select>
                        </div>
                    </div>
                    <div class="pending-header-select-mobile-inline" *ngIf="hasBothInvoiceTypes">
                        <app-select
                            [small]="true"
                            [placeholder]="'select' | translate"
                            [options]="availableTypes"
                            [selectedValue]="selectedValue"
                            [required]="false"
                            [disabled]="false"
                            [searchable]="false"
                            [isClearable]="false"
                            (selectedValueChanged)="onApplicationFilter($event)"
                        ></app-select>
                    </div>
                    <div class="pending-header-select-mobile" *ngIf="hasBothInvoiceTypes">
                        <app-select
                            [small]="true"
                            [placeholder]="'select' | translate"
                            [options]="availableTypes"
                            [selectedValue]="selectedValue"
                            [required]="false"
                            [disabled]="false"
                            [searchable]="false"
                            [isClearable]="false"
                            (selectedValueChanged)="onApplicationFilter($event)"
                        ></app-select>
                    </div>
                    <span class="pending-header-subtitle">{{ 'commissions.select_the_commissions_you_want_to_cash_out' | translate }}</span>
                </div>
                <div class="pending-header-right">
                    <div class="pending-header-select-tablet" *ngIf="hasBothInvoiceTypes">
                        <app-select
                            [small]="true"
                            [placeholder]="'select' | translate"
                            [options]="availableTypes"
                            [selectedValue]="selectedValue"
                            [required]="false"
                            [disabled]="false"
                            [searchable]="false"
                            [isClearable]="false"
                            (selectedValueChanged)="onApplicationFilter($event)"
                        ></app-select>
                    </div>
                    <div class="border border-2 border-primary background-light-01 p-2 flex flex-col items-center pending-header-total-box">
                        <span class="typography-title-s">{{ 'commissions.accumulated_commissions_1' | translate }}:</span>
                        <span class="typography-title-m text-primary">{{ formatAmount(totalPendingAmount) }} {{ getCoinOfCommissionsPending() }}</span>
                    </div>
                </div>
            </div>
            <!-- requested headers -->
            <div class="flex flex-col md:flex-row justify-between items-start" *ngIf="tab === 'REQUESTED'">
                <div class="flex flex-col md:flex-row items-center gap-4">
                    <div class="flex-col">
                        <span class="typography-title-m mb-4">{{ 'commissions.requested_commissions' | translate }}</span>
                        <span class="block mt-4 mb-4">{{ 'commissions.check_the_bonuses_you_have_applied_for_and_their_status' | translate }}</span>
                    </div>
                </div>
                <div class="border border-2 border-primary background-light-01 p-2 flex flex-col items-center">
                    <span class="typography-title-s">{{ 'commissions.accumulated_commissions_2' | translate }}:</span>
                    <span class="typography-title-m text-primary">{{ getAmountSumOfRequestedCommissions() }} {{ getCoinOfCommissionsPending() }}</span>
                </div>
            </div>
            <div class="">
                <div class="w-full divider mt-4 mb-4" *ngIf="tab == 'REQUESTED' || tab == 'TO_REQUEST'"></div>

                <div *ngIf="tab == 'REQUESTING'" class="flex flex-col">
                    <span class="block typography-title-m">{{ 'commissions.summary_of_the_projects_included_in_the_commission' | translate }}</span>
                    <div class="w-full divider mt-2 mb-4"></div>
                    <div class="requesting-summary-row">
                        <div class="requesting-summary-item requesting-summary-item-amount flex flex-col justify-between items-start mb-4">
                            <span class="mb-2">{{ 'commissions.total_amount' | translate }}:</span>
                            <span class="typography-body-m-medium">{{ getAmountSumOfSelectedCommissions() }}</span>
                        </div>
                        <div class="requesting-summary-item requesting-summary-item-requester flex flex-col justify-between items-start mb-4">
                            <span class="mb-2">{{ 'commissions.requested_by' | translate }}:</span>
                            <span class="typography-body-m-medium">{{ userInfo.firstName }} {{ userInfo.lastName }}</span>
                        </div>
                        <div class="requesting-summary-item requesting-summary-item-date flex flex-col justify-between items-start mb-4">
                            <span class="mb-2">{{ 'commissions.requested_date' | translate }}:</span>
                            <span class="typography-body-m-medium">{{ today | date }}</span>
                        </div>
                    </div>
                    <div *ngIf="selectedInvoiceType === 'AUTOMATIC_INVOICE'">
                        <div class="requesting-projects-block">
                            <span>{{ 'commissions.projects_included' | translate }}:</span>
                            <span class="typography-body-m-medium">{{ automaticInvoiceIncludedProjects }}</span>
                        </div>

                        <span class="block typography-title-m">{{ 'commissions.invoice_data' | translate }}</span>
                        <div class="w-full divider mt-2 mb-4"></div>

                        <div class="requesting-invoice-grid">
                            <div class="w-1/2">
                                <label class="block mb-2">{{ 'commissions.invoice_type' | translate }}</label>
                                <app-input class="disabled requesting-input-full" min="0" value="{{ 'commissions.automatic' | translate }}" [disabled]="true"></app-input>
                            </div>
                            <div class="w-1/2">
                                <label class="block mb-2">{{ 'commissions.commission_amount_automatic' | translate }}</label>
                                <app-input
                                    class="disabled requesting-input-full"
                                    min="0"
                                    placeholder="{{ getAmountSumOfSelectedCommissions() }} {{ getCoinOfCommissionsPending() }}"
                                    value="{{ getAmountSumOfSelectedCommissions() }} {{ getCoinOfCommissionsPending() }}"
                                    [disabled]="true"
                                ></app-input>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedInvoiceType === 'MANUAL_INVOICE'" class="requesting-manual-block">
                        <span class="block typography-title-m">{{ 'commissions.invoice_data' | translate }}</span>
                        <div class="w-full divider mt-2 mb-4"></div>

                        <div class="requesting-projects-block">
                            <span>{{ 'commissions.projects_included' | translate }}:</span>
                            <div class="flex flex-col gap-2 sm:grid sm:grid-cols-2 sm:gap-4" *ngFor="let project of manualInvoiceProjectsWithReferences">
                                <span class="typography-body-m-medium">{{ project.projectName }}</span>
                                <span class="typography-body-m-medium">{{ 'commissions.reference' | translate }}: {{ project.references }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full md:overflow-x-auto pending-table-desktop" *ngIf="tab == 'TO_REQUEST'">
                    <app-table
                        class="block min-w-[980px]"
                        [data]="pendingCommissionsData"
                        [columns]="pendingCommissionsColumns"
                        [selectable]="true"
                        [noDataMessage]="'myrewards.no_results_found' | translate"
                        (selectionChanged)="this.selectCommission($event)"
                    ></app-table>
                </div>
                <div class="pending-table-mobile" *ngIf="tab == 'TO_REQUEST'">
                    <div class="pending-mobile-empty" *ngIf="!pendingCommissionsData?.length">{{ 'myrewards.no_results_found' | translate }}</div>

                    <div class="pending-mobile-header" *ngIf="pendingCommissionsData?.length">
                        <span class="pending-mobile-header-title">{{ 'commissions.project_name' | translate }}</span>
                    </div>

                    <div class="pending-mobile-row" *ngFor="let row of pendingCommissionsData">
                        <div class="pending-mobile-main-row">
                            <div class="pending-mobile-left">
                                <input
                                    type="checkbox"
                                    [checked]="isPendingCommissionSelected(row)"
                                    (change)="onPendingCommissionSelectionChange(row, $any($event.target).checked)"
                                />
                                <span
                                    class="pending-mobile-project"
                                    [matTooltip]="row.projectName"
                                    matTooltipPosition="above"
                                    [matTooltipShowDelay]="300"
                                    matTooltipClass="custom-tooltip"
                                >{{ row.projectName }}</span>
                            </div>

                            <button class="pending-mobile-toggle" type="button" (click)="togglePendingCommissionDetails(row)">
                                <svg *ngIf="!isPendingCommissionExpanded(row)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M12.0051 15.025L6.70508 9.725L7.40508 9L12.0051 13.6L16.6051 9L17.3051 9.725L12.0051 15.025Z" fill="#232323"/>
                                </svg>
                                <svg *ngIf="isPendingCommissionExpanded(row)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M7.4002 14.7L6.7002 14L12.0002 8.67505L17.3002 14L16.6002 14.7L12.0002 10.1L7.4002 14.7Z" fill="#232323"/>
                                </svg>
                            </button>
                        </div>

                        <div class="pending-mobile-details" *ngIf="isPendingCommissionExpanded(row)">
                            <span>{{ 'commissions.reference' | translate }}: {{ row.poNumber }}</span>
                            <span>{{ 'commissions.expiration_date' | translate }}: {{ row.sapBonusExpiredDate }}</span>
                            <span>{{ 'commissions.desginer' | translate }}: {{ row.memberName }}</span>
                            <span>{{ 'commissions.amount' | translate }}: {{ row.amount }}</span>
                        </div>
                    </div>
                </div>
                <div class="table-container requested-table-wrapper w-full" *ngIf="tab == 'REQUESTED'">
                    <table class="material-table requested-table w-full bg-white border-collapse">
                        <thead>
                            <tr class="bg-background-light-01 border-b border-text-terciary">
                                <th class="typography-table-m p-2 text-left">{{ 'commissions.status' | translate }}</th>
                                <th class="typography-table-m p-2 text-left requested-project-col">{{ 'commissions.project_name' | translate }}</th>
                                <th class="typography-table-m p-2 text-left">{{ 'commissions.requested_date' | translate }}</th>
                                <th class="typography-table-m p-2 text-left requested-designer-col">{{ 'commissions.desginer' | translate }}</th>
                                <th class="typography-table-m p-2 text-left requested-amount-col">{{ 'commissions.amount' | translate }}</th>
                                <th class="typography-table-m p-2 text-left requested-reference-col">{{ 'commissions.reference' | translate }}</th>
                                <th class="typography-table-m p-2 text-left">{{ 'commissions.invoice' | translate }}</th>
                                <th class="typography-table-m p-2 w-[44px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!requestedCommissionsData?.length">
                                <td class="text-center p-6" colspan="8">{{ 'myrewards.no_results_found' | translate }}</td>
                            </tr>

                            <ng-container *ngFor="let row of requestedCommissionsData">
                                <tr class="border-b border-text-terciary" [class.border-b-0]="isRequestedCommissionExpanded(row)">
                                    <td class="p-2">
                                        <span
                                            class="inline-flex items-center rounded-sm px-2 py-1 typography-body-s-medium whitespace-nowrap"
                                            [ngStyle]="getRequestedCommissionStatusStyle(row.status)">
                                            {{ getRequestedCommissionStatusLabel(row) }}
                                        </span>
                                    </td>
                                    <td class="p-2 typography-body-m-regular requested-project-col">
                                        <span
                                            class="block requested-project-cell"
                                            [matTooltip]="row.projectName"
                                            matTooltipPosition="above"
                                            [matTooltipShowDelay]="300"
                                            matTooltipClass="custom-tooltip"
                                        >{{ row.projectName }}</span>
                                    </td>
                                    <td class="p-2 typography-body-m-regular whitespace-nowrap">{{ row.requestedDate | date }}</td>
                                    <td class="p-2 typography-body-m-regular requested-designer-col">
                                        <span
                                            class="block requested-designer-cell"
                                            [matTooltip]="row.memberName"
                                            matTooltipPosition="above"
                                            [matTooltipShowDelay]="300"
                                            matTooltipClass="custom-tooltip"
                                        >{{ row.memberName }}</span>
                                    </td>
                                    <td class="p-2 typography-body-m-regular whitespace-nowrap requested-amount-col">{{ row.amount }}</td>
                                    <td class="p-2 typography-body-m-regular requested-reference-col">
                                        <span
                                            class="block requested-reference-cell"
                                            [matTooltip]="row.poNumber"
                                            matTooltipPosition="above"
                                            [matTooltipShowDelay]="300"
                                            matTooltipClass="custom-tooltip"
                                        >{{ row.poNumber }}</span>
                                    </td>
                                    <td class="p-2 typography-body-m-regular">
                                        <ng-container *ngIf="row.invoiceUrl; else noInvoiceLink">
                                            <a [href]="row.invoiceUrl" target="_blank" class="text-primary no-underline cursor-pointer whitespace-nowrap" style="text-decoration: none">
                                                {{ 'commissions.view_invoice' | translate }}
                                            </a>
                                        </ng-container>
                                        <ng-template #noInvoiceLink>
                                            <span class="text-text-state-disabled whitespace-nowrap">{{ 'commissions.not_available_yet' | translate }}</span>
                                        </ng-template>
                                    </td>
                                    <td class="p-2 text-center">
                                        <button class="text-text-secondary bg-transparent border-0 p-1 m-0 inline-flex items-center justify-center cursor-pointer rounded hover:bg-gray-100 transition-colors" type="button" (click)="toggleRequestedCommissionDetails(row)">
                                            <svg *ngIf="!isRequestedCommissionExpanded(row)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                <path d="M12.0051 15.025L6.70508 9.725L7.40508 9L12.0051 13.6L16.6051 9L17.3051 9.725L12.0051 15.025Z" fill="#232323"/>
                                            </svg>
                                            <svg *ngIf="isRequestedCommissionExpanded(row)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                <path d="M7.4002 14.7L6.7002 14L12.0002 8.67505L17.3002 14L16.6002 14.7L12.0002 10.1L7.4002 14.7Z" fill="#232323"/>
                                            </svg>
                                        </button>
                                    </td>
                                </tr>

                                <tr *ngIf="isRequestedCommissionExpanded(row)" class="border-b border-text-terciary">
                                    <td colspan="8" class="p-4">
                                        <div class="flex flex-col gap-3">
                                            <span class="typography-body-m-medium">{{ 'commissions.summary_of_the_projects_included_in_the_commission' | translate }}</span>
                                            <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4" *ngFor="let projectDetail of getRequestedCommissionProjectDetails(row)">
                                                <span class="typography-body-m-regular">{{ 'commissions.project_name' | translate }}: {{ projectDetail.projectName }}</span>
                                                <span class="typography-body-m-regular">{{ 'commissions.reference' | translate }}: {{ getProjectDetailReferences(projectDetail) }}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

                <div class="requested-table-mobile" *ngIf="tab == 'REQUESTED'">
                    <div class="requested-mobile-empty" *ngIf="!requestedCommissionsData?.length">{{ 'myrewards.no_results_found' | translate }}</div>

                    <div class="requested-mobile-header" *ngIf="requestedCommissionsData?.length">
                        <span class="requested-mobile-header-title">{{ 'commissions.project_name' | translate }}</span>
                    </div>

                    <div class="requested-mobile-row" *ngFor="let row of requestedCommissionsData">
                        <div class="requested-mobile-main-row">
                            <span
                                class="requested-mobile-project"
                                [matTooltip]="row.projectName"
                                matTooltipPosition="above"
                                [matTooltipShowDelay]="300"
                                matTooltipClass="custom-tooltip"
                            >{{ row.projectName }}</span>

                            <button class="requested-mobile-toggle" type="button" (click)="toggleRequestedCommissionDetails(row)">
                                <svg *ngIf="!isRequestedCommissionExpanded(row)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M12.0051 15.025L6.70508 9.725L7.40508 9L12.0051 13.6L16.6051 9L17.3051 9.725L12.0051 15.025Z" fill="#232323"/>
                                </svg>
                                <svg *ngIf="isRequestedCommissionExpanded(row)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M7.4002 14.7L6.7002 14L12.0002 8.67505L17.3002 14L16.6002 14.7L12.0002 10.1L7.4002 14.7Z" fill="#232323"/>
                                </svg>
                            </button>
                        </div>

                        <div class="requested-mobile-details" *ngIf="isRequestedCommissionExpanded(row)">
                            <span>{{ 'commissions.status' | translate }}: {{ getRequestedCommissionStatusLabel(row) }}</span>
                            <span>{{ 'commissions.requested_date' | translate }}: {{ row.requestedDate | date }}</span>
                            <span>{{ 'commissions.desginer' | translate }}: {{ row.memberName }}</span>
                            <span>{{ 'commissions.amount' | translate }}: {{ row.amount }}</span>
                            <span>
                                {{ 'commissions.invoice' | translate }}:
                                <ng-container *ngIf="row.invoiceUrl; else noMobileInvoiceLink">
                                    <a [href]="row.invoiceUrl" target="_blank" class="text-primary no-underline cursor-pointer">{{ 'commissions.view_invoice' | translate }}</a>
                                </ng-container>
                                <ng-template #noMobileInvoiceLink>{{ 'commissions.not_available_yet' | translate }}</ng-template>
                            </span>

                            <div class="requested-mobile-project-summary">
                                <span class="typography-body-m-medium">{{ 'commissions.summary_of_the_projects_included_in_the_commission' | translate }}</span>
                                <div class="flex flex-col gap-1" *ngFor="let projectDetail of getRequestedCommissionProjectDetails(row)">
                                    <span>{{ 'commissions.project_name' | translate }}: {{ projectDetail.projectName }}</span>
                                    <span>{{ 'commissions.reference' | translate }}: {{ getProjectDetailReferences(projectDetail) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<app-table
                    [overFlowXEnabled]="true"
                    [data]="pendingCommissionsData"
                    [columns]="pendingCommissionsColumns"
                    [selectable]="true"
                    [noDataMessage]="'myrewards.no_results_found' | translate"
                    (selectionChanged)="this.selectCommission($event)"
                    *ngIf="tab == 'TO_REQUEST'"
                ></app-table>
                <app-table
                    [overFlowXEnabled]="true"
                    [data]="requestedCommissionsData"
                    [columns]="requestedCommissionsColumns"
                    [noDataMessage]="'myrewards.no_results_found' | translate"
                    (selectionChanged)="this.selectCommission($event)"
                    *ngIf="tab == 'REQUESTED'"
                ></app-table>-->
            </div>
            <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (onPageChange)="onPageChange($event)" *ngIf="shouldShowPagination">
            </app-pagination>
        </div>

        <!-- Navigation Buttons -->
        <div class="bg-white request-actions-block px-4 sm:px-6 py-4 flex flex-col md:flex-row md:justify-end md:items-center gap-3">
            <div>
                <div class="flex flex-col sm:flex-row items-stretch sm:items-center">
                    <div class="gap-2 flex flex-row items-center" *ngIf="tab === 'TO_REQUEST'">
                        <span>{{ 'commissions.total_to_be_requested' | translate }}:</span>
                        <span class="typography-title-l text-primary">{{ getAmountSumOfSelectedCommissions() }} {{ getCoinOfCommissionsPending() }}</span>
                        <app-button [primary]="true" class="md:w-auto" size="L" [disabled]="this.selectedCommissions.length == 0" (click)="filterCommissions('REQUESTING')">
                            {{ 'commissions.request_commission' | translate }}
                        </app-button>
                    </div>
                </div>
                <div class="flex flex-col sm:flex-row items-stretch sm:items-center" *ngIf="tab === 'REQUESTING'">
                    <app-button [primary]="true" class="w-full sm:w-auto md:w-auto" size="L" (click)="requestCommissions()">
                        {{ 'commissions.request_commission' | translate }}
                    </app-button>
                </div>
            </div>
        </div>
        <alert type="info" *ngIf="selectedInvoiceType === 'AUTOMATIC_INVOICE'">
            <span>{{ 'commissions.automatic_invoice_disclaimer_title' | translate }}</span>
            <ul>
                <li>{{ 'commissions.automatic_invoice_disclaimer_1' | translate }}</li>
                <li>{{ 'commissions.automatic_invoice_disclaimer_2' | translate }}</li>
            </ul>
        </alert>
        <alert type="info" *ngIf="selectedInvoiceType === 'MANUAL_INVOICE'">
            <span>{{ 'commissions.manual_invoice_disclaimer_title' | translate }}</span>
            <ol>
                <li>{{ 'commissions.manual_invoice_disclaimer_1' | translate }}</li>
                <li>{{ (isUsOrCaCountry ? 'commissions.manual_invoice_disclaimer_2_us_ca' : 'commissions.manual_invoice_disclaimer_2') | translate }}</li>
                <li>{{ 'commissions.manual_invoice_disclaimer_3' | translate }}</li>
            </ol>
        </alert>

        <app-confirm-modal
            [isOpen]="isRequestResultModalOpen"
            [title]="requestResultModalTitle"
            [message]="requestResultModalMessage"
            [confirmText]="'common.buttons.close' | translate"
            [cancelText]="''"
            (onConfirm)="closeRequestResultModal()"
            (onClose)="closeRequestResultModal()"
            [maxWidth]="'580'"
        ></app-confirm-modal>
    </div>
</div>
